/*
 * @Author: your name
 * @Date: 2020-08-21 18:15:16
 * @LastEditTime: 2020-09-14 13:59:54
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \eunke-st-www\src\server\business.js
 */
import http from "../utils/http";
export default{
    waybillPage:function(data,fun){
        http.post("/business/waybill-page",data,fun)
    },  
    designateWaybill:function(data,fun){
        http.put("/business/designate-waybill",data,fun)
    }, 
    userPage:function(data,fun){
        http.get("/appuser/selectUnAcceptDriver",data,fun)
    }, 
    deleteWaybill:function(num,fun){
        http.delete("/business/delete-waybill/"+num,fun)
    },  
    completeSt:function(data,fun){
        http.put("/business/complete-st",data,fun)
    }, 
    driverLocationPage:function(data,fun){
        http.get("/business/driver-location-page",data,fun)
    }, 
    business:function(fun){
        http.get("/business",fun)
    },
    getCurUserInfo(fun) {
        http.get("/auth/userinfo",fun)
    },
    bindUserToOwner(data, fun) {
        http.put("/user/band-owner", data, fun)
    },
    sendCode(phone, fun) {
        http.get("/user/band-owner/sms/" + phone, fun)
    },
    unbindOwner(fun) {
        http.delete("/user/unband-owner", fun)
    },
    countDistance(data, fun) {
        http.post("/business/calculator-distance", data, fun)
    },
    getVehicleList(data,fun) {
        http.get("/base-data/vehicle-list",data, fun)
    },
    getGoodsList(fun) {
        http.get("/base-data/goods-list", fun)
    },
    waybillCreate(data, fun) {
        http.post("/business/waybill-create", data, fun)
    },
    waybillPriceView(data, fun) {
        http.post("/business/calculator-adminFee", data, fun)
    },
    getFranchiseList(data, fun) {
        http.get("/base-data/franchise", fun)
    },
    checkPayStatus(data, fun) {
        http.get(`/business/confirm-payment-state/${data}`, fun)
    },
    wxpay(waybillNo, fun) {
        http.get(`/business/wxpay/${waybillNo}`, fun)
    },
    getWaybillCount(data, fun) {
        http.post("/business/waybill-page-count",data,fun)
    },
	//获取加盟物流合计
	getLogisticsWaybillCount(data, fun) {
	    http.post("/logistics-waybill/query-count",data,fun)
	},
    cancelWaybill(waybillNo, fun) {
        http.put(`/business/cancelWaybill/${waybillNo}`,fun)
    },
    completeWaybill(waybillNo, fun) {
        http.put(`/business/complete/${waybillNo}`,fun)
    },
    waybillDetail(waybillNo, fun) {
        http.get(`/business/waybillDetail/${waybillNo}`,fun)
    },
	//获取加盟物流名称列表
	getCompany(fun) {
        http.get("/base-data/company/list", fun)
    },
	    //获取加盟物流子单
    getLogisticsWaybill:function(data,fun){
         http.post("/logistics-waybill/query",data,fun)
    },  

	logiswaybillDetail(waybillNo, fun) {
	    http.post(`/logistics-waybill/detail/${waybillNo}`,fun)
	},
}